import gql from "graphql-tag";
import { LOGGED_IN_USER_DATA_FIELDS } from "screens/LoginRegistration/queries";

export const SEND_OTP = gql`
  mutation UserRequestOTP($user_id: ID, $mobile: String!, $type: OtpType!) {
    userRequestOtp(user_id: $user_id, mobile: $mobile, type: $type)
  }
`;

export const OTP_LOGIN = gql`
  mutation UserOtpLogin($userId: UUID!, $otp: String!, $clientId: String!) {
    userOtpLogin(user_id: $userId, otp: $otp, client_id: $clientId) {
      ...on User {
        ${LOGGED_IN_USER_DATA_FIELDS}
      }
    }
  }
  
`;

export const VERIFY_USER_MOBILE = gql`
  mutation VerifyUserMobile(
    $userId: UUID!
    $otp: String!
    $clientId: String!
    $mobile: String
    $referralCode: String
  ) {
    verifyUserMobile(
      user_id: $userId
      otp: $otp
      client_id: $clientId
      mobile_number: $mobile
      referral_code:$referralCode
    ) {
      ...on User {
        ${LOGGED_IN_USER_DATA_FIELDS}
      }
    }
  }
`;
